import React, { useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import {
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    List,
    ListItem,
    ListItemText,
    CardActions,
    CardMedia
} from "@mui/material";
import { Helmet } from "react-helmet";
const services = [
    {
        title: "Wall Putty",
        description: "Smoothens wall surface and fills cracks for a perfect paint-ready base.",
        image: "/assets/premium_photo-1700237621949-c7850c78d2ac.avif",
        process: [
            "Surface Inspection & Cleaning",
            "Primer Application (if required)",
            "First Coat of Putty",
            "Drying & Sanding",
            "Second Coat of Putty",
            "Final Finishing"
        ],
        benefits: [
            "Crack-free wall surface",
            "Longer paint life",
            "Reduces paint consumption"
        ],
        serviceTypes: [
            "White Cement-Based Putty",
            "Acrylic Wall Putty",
            "Customized Mixes"
        ],
        locations: [
            "New Walls",
            "Renovated Walls",
            "Ceilings",
            "Damp-Prone Areas"
        ]
    },
    {
        title: "Emulsion Paints",
        description: "Interior & Exterior emulsion paint services for smooth, vibrant, and durable finishes.",
        image: "/assets/premium_photo-1664303562514-3a923e14732e.avif",
        process: [
            "Surface Preparation  Cleaning the wall surface of dust, grease, and old paint flakes.",
            "Putty & Primer  Applying wall putty (if needed) and a coat of primer for better paint grip.",
            "Paint Mixing  Emulsion is mixed in appropriate ratio with water as per manufacturer instructions.",
            "First Coat Application  Evenly applied using rollers/brushes and allowed to dry.",
            "Second Coat Application  Final coat is applied for a smooth and rich finish.",
            "Final Touch-up  Edges and corners are cleaned and any missed spots are touched up."
        ],
        benefits: [
            "Durable and long-lasting finish",
            "Quick drying and low odor",
            "Washable surface  easy to maintain",
            "Available in matte, satin, and glossy variants",
            "Better aesthetics and moisture resistance"
        ],
        serviceTypes: [
            "Interior Emulsion  For living rooms, bedrooms, and ceilings",
            "Exterior Emulsion  Weather-resistant and UV-protective paints",
            "Premium Emulsions  For luxury smooth finish with high coverage",
            "Eco-friendly Low VOC Paints  Safe for health and the environment"
        ],
        locations: [
            "Home Interiors (walls & ceilings)",
            "Building Exteriors (cement walls)",
            "Offices & Commercial Spaces",
            "New Constructions and Repaints"
        ]
    },

    {
        title: "Royal & Premium Paints",
        description: "Luxurious high-sheen paint for elegant walls with smooth texture and deep color finish.",

        image: "/assets/R.jpeg",
        process: [
            "Surface Cleaning & Priming  Remove dust, old paint; apply primer.",
            "Putty Application  Fill cracks and uneven areas with wall putty.",
            "Sanding  Smooth the surface to prepare for a fine finish.",
            "Base Coat  Apply emulsion as a base layer.",
            "Royal Paint Application  Apply 2 coats of Royal or Premium paint using brush/roller.",
            "Final Touch-up  Neat edges, smooth finish, color correction if needed."
        ],
        benefits: [
            "Gives a luxurious, royal appearance to walls.",
            "High stain resistance and washable.",
            "Long-lasting smooth and glossy finish.",
            "Available in silk, velvet, and metallic textures.",
            "Moisture and fungus-resistant."
        ],
        serviceTypes: [
            "Asian Paints Royale",
            "Dulux Velvet Touch",
            "Nerolac Impressions",
            "Berger Silk Glamour"
        ],
        locations: [
            "Living rooms and bedrooms",
            "Feature walls and ceilings",
            "Luxury homes and villas",
            "Offices and showrooms"
        ]
    },

    {
        title: "Polish Work",
        description: "Protects and enhances wooden surfaces with glossy or matte PU and melamine polish.",
        image: "/assets/OIP.webp",
        process: [
            "Sanding – Remove old polish and smoothen the wood surface.",
            "Stain Application – Apply wood stain if required for color tone.",
            "Base Coat – First layer of melamine or PU is sprayed or brushed.",
            "Drying – Surface is left to dry completely.",
            "Intermediate Sanding – Light sanding between coats for a smooth feel.",
            "Final Coat – Final polish layer is applied for shine and protection."
        ],
        benefits: [
            "Enhances natural wood grain.",
            "Protects wood from moisture and scratches.",
            "Available in matte, semi-gloss, and glossy finishes.",
            "PU offers superior durability over traditional polish.",
            "Melamine gives smooth and budget-friendly finish."
        ],
        serviceTypes: [
            "PU Polish (Polyurethane)",
            "Melamine Polish",
            "French Polish",
            "Natural Wood Finish"
        ],
        locations: [
            "Wooden doors and windows",
            "Modular furniture",
            "Wardrobes & cabinets",
            "Tables and decorative units"
        ]
    }
    ,
    {
        title: "Indigo Colours",
        description: "Eco-friendly paints with rich colors and long-lasting protection for all surfaces.",
        image: "/assets/Indigo-DW-Exterior-Laminate-2.webp",
        process: [
            "Surface Preparation  Clean and repair the surface.",
            "Putty/Primer  Apply putty and Indigo primer if needed.",
            "Base Coat  Apply base emulsion or undercoat.",
            "Color Selection  Choose Indigo shade based on surface.",
            "Paint Application  Apply 2 coats using brush/roller/spray.",
            "Final Finish  Clean edges and touch up for perfection."
        ],
        benefits: [
            "Eco-friendly, low VOC paint options.",
            "Weather-proof and high-coverage formulas.",
            "Resistant to algae, dirt, and dampness.",
            "Wide shade range with modern colors.",
            "Affordable with premium performance."
        ],
        serviceTypes: [
            "Interior Emulsions",
            "Exterior Emulsions",
            "Floor Paints",
            "Metal and Wood Finishes"
        ],
        locations: [
            "Home interiors and exteriors",
            "Compound walls and gates",
            "Wooden and metal furniture",
            "Commercial and industrial spaces"
        ]
    }, {
        title: "Waterproofing",
        description: "Protect your home from water damage with expert waterproofing solutions for roofs, walls, and basements.",
        image: "/assets/waterproof-coating.jpg", // optional: replace with your image path
        process: [
            "Surface Cleaning – Remove dust, loose plaster, algae, and grease.",
            "Crack Filling – Identify and fill cracks with waterproof crack sealants.",
            "Primer Application – Apply waterproofing primer for bonding.",
            "Waterproof Coat – Apply liquid waterproofing membrane or cementitious coating.",
            "Drying – Allow each coat to dry completely before applying the next.",
            "Top Coat/Protection – Apply a final coat or screed for surface protection."
        ],
        benefits: [
            "Prevents water leakage and dampness.",
            "Protects walls, ceilings, and basements from damage.",
            "Improves structure life and paint durability.",
            "Resists fungal growth and peeling paint.",
            "Works for old and new construction."
        ],
        serviceTypes: [
            "Terrace Waterproofing",
            "Bathroom & Tile Joint Sealing",
            "Basement Waterproofing",
            "External Wall Waterproofing",
            "Crack Filling and Treatment"
        ],
        locations: [
            "Terraces and Roof Slabs",
            "Bathroom and Wet Areas",
            "Exterior Walls and Balconies",
            "Basements and Underground Tanks",
            "Kitchens and Utility Rooms"
        ]
    }


];


function Services() {
    const [open, setOpen] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const theme = useTheme();

    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const handleOpen = (service) => {
        setSelectedService(service);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedService(null);
    };

    return (
        <>
            <Helmet>
                <title>Our Painting Services | PM Painters India</title>
                <meta name="description" content="Explore our full range of services including interior & exterior painting, waterproofing, texture walls, and more. Serving all over India." />
                <meta name="keywords" content="interior painting, exterior painting, waterproofing, texture painting, wall painting services India" />
            </Helmet>
            <Container maxWidth="lg" sx={{ mt: 4 }}>
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    <Typography variant="h4" gutterBottom align="center">
                        Our Services
                    </Typography>
                </motion.div>

                <Grid container spacing={4} sx={{ my: 4 }}>
                    {services.map((service, index) => (
                        <Grid item xs={6} sm={6} md={6} key={index}>
                            <Card sx={{ maxWidth: 345 }}>
                                <CardMedia
                                    component="img"
                                    sx={{
                                        height: 150, // Always same height for image
                                        width: "100%",
                                        objectFit: "cover",
                                    }}
                                    image={service.image}
                                />
                                <CardContent sx={{
                                    height: 150, // Lock content area (330 - 180 image)
                                    p: 2,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'flex-start',
                                }} >
                                    <Typography gutterBottom variant="h5" component="div">
                                        {service.title}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        {service.description}
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    {service.process && (
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            sx={{ mt: "auto", alignSelf: "flex-start" }}
                                            onClick={() => handleOpen(service)}
                                        >
                                            View Process
                                        </Button>
                                    )}
                                </CardActions>
                            </Card>


                        </Grid>
                    ))}
                </Grid>

                {/* Modal */}
                <Dialog
                    open={open}
                    onClose={handleClose}
                    fullScreen={fullScreen}
                    maxWidth="sm"
                    fullWidth
                    scroll="paper"
                >
                    <DialogTitle>{selectedService?.title} – Details</DialogTitle>
                    <DialogContent dividers>
                        {selectedService?.process && (
                            <>
                                <Typography variant="subtitle1">🛠️ Process</Typography>
                                <List dense>
                                    {selectedService.process.map((item, idx) => (
                                        <ListItem key={idx}>
                                            <ListItemText primary={`• ${item}`} />
                                        </ListItem>
                                    ))}
                                </List>
                            </>
                        )}

                        {selectedService?.benefits && (
                            <>
                                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                                    ✅ Benefits
                                </Typography>
                                <List dense>
                                    {selectedService.benefits.map((item, idx) => (
                                        <ListItem key={idx}>
                                            <ListItemText primary={`✔️ ${item}`} />
                                        </ListItem>
                                    ))}
                                </List>
                            </>
                        )}

                        {selectedService?.serviceTypes && (
                            <>
                                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                                    🧪 Types of Paint / Putty
                                </Typography>
                                <List dense>
                                    {selectedService.serviceTypes.map((type, idx) => (
                                        <ListItem key={idx}>
                                            <ListItemText primary={`• ${type}`} />
                                        </ListItem>
                                    ))}
                                </List>
                            </>
                        )}

                        {selectedService?.locations && (
                            <>
                                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                                    📍 Applied At
                                </Typography>
                                <List dense>
                                    {selectedService.locations.map((loc, idx) => (
                                        <ListItem key={idx}>
                                            <ListItemText primary={`• ${loc}`} />
                                        </ListItem>
                                    ))}
                                </List>
                            </>
                        )}
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose} variant="contained" color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </>
    );
}




export default Services;
